export default __webpack_public_path__ + "static/media/health-risks-main.d06f9747.svg";